/*******************************************
*  Mixin to generate typographic pairings of heading and paragraph: h2-p, h3-p, etc, etc.
*******************************************/
/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-form-group.get-names.ts 
*/
:host {
  box-sizing: border-box;
  width: 100%;
}
:host * {
  box-sizing: border-box;
}

.ace-form-group {
  width: 100%;
}
.ace-form-group__headline {
  display: block;
  padding-bottom: var(--ace-primitive-spacing-normal);
}
.ace-form-group__errors {
  display: flex;
  flex-direction: column;
  gap: var(--ace-primitive-spacing-xx-tight);
  margin-top: var(--ace-primitive-spacing-x-tight);
}